<div [id]="completeProfileButtonId">
  <markant-button
    data-cy="complete-profile-button"
    [disabled]="isFurtherQualificationProcessInProgress"
    (click)="openCompleteProfileDialogVisibility()"
    color-scheme="primary"
    variant="clear"
  >
    {{ 'catalog.detail.cartridgeVariants.demo.completeProfile' | transloco }}
  </markant-button>
</div>
@if (isFurtherQualificationProcessInProgress) {
  <markant-tooltip
    [for]="completeProfileButtonId"
    [label]="
      'catalog.detail.cartridgeVariants.demo.furtherRequestAlreadyStartedTooltip'
        | transloco
    "
    placement="top"
  ></markant-tooltip>
}
